// NOTE (Nick, 2026-02-23, REPL-23283): Isolate non-OpenCode scaffold errors
// from the main Editor Sentry stream.

import {
  BrowserClient,
  defaultStackParser,
  makeFetchTransport,
  Scope,
} from "@sentry/react";

const NON_OPENCODE_SCAFFOLD_SENTRY_DSN =
  "https://ad3d68c8b19977b6d0c6418bd62247af@o1267142.ingest.us.sentry.io/4510937298632704";

type ScaffoldErrorExtras = {
  pageRoute: string;
  stack?: string;
  componentStack?: string;
};

function createScaffoldSentryScope(dsn: string): Scope | null {
  if (!dsn) {
    return null;
  }

  const client = new BrowserClient({
    dsn,
    transport: makeFetchTransport,
    stackParser: defaultStackParser,
    integrations: [],
    tracesSampleRate: 0,
    profilesSampleRate: 0,
  });

  const scope = new Scope();
  scope.setClient(client);
  return scope;
}

let nonOpencodeScope: Scope | null | undefined;

function getNonOpencodeScope(): Scope | null {
  if (nonOpencodeScope === undefined) {
    nonOpencodeScope = createScaffoldSentryScope(
      NON_OPENCODE_SCAFFOLD_SENTRY_DSN,
    );
  }
  return nonOpencodeScope;
}

function captureToScope(
  scope: Scope | null,
  error: Error,
  extras: ScaffoldErrorExtras,
) {
  if (!scope) {
    return;
  }

  scope.setExtras({
    ...extras,
    url: window.location.href,
  });
  scope.captureException(error);
}

export function trackNonOpencodeScaffoldError(
  error: Error,
  extras: ScaffoldErrorExtras,
) {
  captureToScope(getNonOpencodeScope(), error, extras);
}
